import React, {
  useState,
  useCallback,
  useEffect,
  useContext,
  useRef,
} from "react";
import { useNavigate } from "react-router-dom";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import StoreContext from "../../components/Store/Context";

import Sidebar from "../../components/Sidebar";
import {
  EditButton,
  Main,
  SubTitle,
  Table,
  Tables,
  Title,
  ReplayButton,
} from "./orderlistcanceled";

import { CloseFilter, Content, DownloadExcelWrapper, Filter, FilterTitle } from "../../utils/stylesbase";
import { Button, Checkbox, FormControlLabel, FormGroup, TextField, Tooltip } from "@mui/material";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { API_URL } from "../../utils/env";

const columnsNames = [
  {
    code: "orderRef",
    name: "#",
  },
  {
    code: "orderPlataform",
    name: "Plataform",
  },
  {
    code: "name",
    name: "Name",
  },
  {
    code: "date",
    name: "Tickets Date",
  },
  {
    code: "sector",
    name: "Tickets",
  },
  {
    code: "currency",
    name: "Currency",
  },
  {
    code: "price",
    name: "Price",
  },
  {
    code: "pax",
    name: "Pax",
  },
  {
    code: "contact",
    name: "Contact",
  },
  {
    code: "discount",
    name: "Discount",
  },
  {
    code: "country",
    name: "Country",
  },
  {
    code: "cancelReason",
    name: "Cancel Reason",
  },
  {
    code: "createdBy",
    name: "Created By",
  },
  {
    code: "lastEditBy",
    name: "Last Edit By",
  },
];


const OrderListCanceled = () => {
  const navigate = useNavigate();
  const MySwal = withReactContent(Swal);

  const [tickets, setTickets] = useState([]);
  const [selectedLines, setSelectedLines] = useState([]);
  const [reset, setReset] = useState(0);
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [activeFilter, setActiveFilter] = useState(false);
  const [filtersOptions, setFiltersOptions] = useState([]);
  const [search, setSearch] = useState("");

  const {
    selectedFiltersInventoryDetails: selectedFilters,
    setSelectedFiltersInventoryDetails: setSelectedFilters,
    canceledIsFiltered: ordersIsFiltered,
    setCanceledIsFiltered: setOrdersIsFiltered,
    sidebarClosed, userName, userPermissions, setSidebarClosed
  } = useContext(StoreContext);

  const tableRef = useRef(null);

  const unDeleteTicket = useCallback(async (ticketId, orderRef) => {
    MySwal.fire({
      title: `Are you sure you want to uncancel the ticket on booking ${orderRef}?`,
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(({ ...params }) => {
      if (params.isConfirmed) {
        const body = {
          createdBy: userName,
          lastEditBy: userName,
        };
        fetch(`${API_URL}tickets/undelete.php?id=${ticketId}`, {
          method: "POST",
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((response) =>
            Swal.fire("Ticket uncancelled successfully!!", "", "success").then(
              () => {
                return navigate("/order-list");
              }
            )
          );
      }
    });
  }, []);

  const editOrder = useCallback((orderId) => {
    navigate(`/order-update?id=${orderId}`);
  }, []);

  const toggleSelectedLine = useCallback(
    (ticketId) => {
      let newSelectedLines = selectedLines;
      if (newSelectedLines.indexOf(ticketId) === -1)
        newSelectedLines.push(ticketId);
      else newSelectedLines.splice(newSelectedLines.indexOf(ticketId), 1);
      setSelectedLines(newSelectedLines);
      setReset(Math.random());
    },
    [selectedLines]
  );

  const openFilter = useCallback(
    (filter) => {
      setSearch("");
      setActiveFilter(filter);
      let options = [];
      tickets.forEach((ticket) => {
        if (options.indexOf(ticket[filter]) === -1) {
          let valid = true;
          selectedFilters.forEach((selectedFilter) => {
            if (
              selectedFilter.selecteds.indexOf(
                ticket[selectedFilter.attributeName]
              ) === -1 &&
              selectedFilter.attributeName !== filter
            )
              valid = false;
          });
          if (valid) options.push(ticket[filter]);
        }
      });
      options = options.sort((a, b) => (a > b ? 1 : -1));
      setFiltersOptions(options);
    },
    [tickets, setActiveFilter, selectedFilters]
  );

  const searchFilters = useCallback(
    (e) => {
      const search = e.target.value;
      const filter = activeFilter;
      setSearch(search);
      let options = [];
      tickets.forEach((ticket) => {
        if (options.indexOf(ticket[filter]) === -1)
          options.push(ticket[filter]);
      });
      options = options.filter((a) =>
        a ? a.toLowerCase().includes(search.toLowerCase()) : false
      );
      options = options.sort((a, b) => (a > b ? 1 : -1));
      setFiltersOptions(options);
    },
    [activeFilter, tickets]
  );

  const closeFilter = useCallback(() => {
    setActiveFilter(false);
  }, [setActiveFilter]);

  const changeFilter = useCallback(
    (e, attribute, option) => {
      let newFilters = selectedFilters;
      if (e.target.checked) {
        if (newFilters.find((item) => item.attributeName === attribute)) {
          newFilters
            .find((item) => item.attributeName === attribute)
            .selecteds.push(option);
        } else {
          newFilters.push({ attributeName: attribute, selecteds: [option] });
        }
      } else {
        newFilters
          .find((item) => item.attributeName === attribute)
          .selecteds.splice(
            newFilters
              .find((item) => item.attributeName === attribute)
              .selecteds.indexOf(option),
            1
          );
      }

      setSelectedFilters(newFilters);
      setReset(Math.random());
    },
    [selectedFilters, activeFilter]
  );


  const checkFilterIsActive = useCallback(
    (option) => {
      if (
        selectedFilters.find((item) => item.attributeName === activeFilter) &&
        selectedFilters
          .find((item) => item.attributeName === activeFilter)
          .selecteds.indexOf(option) !== -1
      )
        return true;
      else return false;
    },
    [activeFilter, selectedFilters, reset]
  );

  const checkIfColumnIsFiltered = useCallback(
    (column) => {
      let filters = [];

      tickets.forEach((ticket) => {
        if (filters.indexOf(ticket[column]) === -1)
          filters.push(ticket[column]);
      });

      const total = filters.length;

      if (
        !selectedFilters.find((filter) => filter.attributeName === column) ||
        !selectedFilters.find((filter) => filter.attributeName === column)
          .selecteds
      )
        return false;

      return (
        selectedFilters.find((filter) => filter.attributeName === column)
          .selecteds.length !== total
      );
    },
    [selectedFilters, tickets]
  );

  const selectAll = useCallback(() => {
    let newFilters = selectedFilters;

    let filter = newFilters.find(
      (filter) => filter.attributeName === activeFilter
    );

    tickets.forEach((ticket) => {
      if (filter.selecteds.indexOf(ticket[activeFilter]) === -1)
        filter.selecteds.push(ticket[activeFilter]);
    });

    newFilters.find(
      (filter) => filter.attributeName === activeFilter
    ).selecteds = filter.selecteds;

    setSelectedFilters(newFilters);
    setReset(Math.random());
  }, [activeFilter, selectedFilters]);

  const clearAll = useCallback(() => {
    let newFilters = selectedFilters;
    newFilters.find(
      (filter) => filter.attributeName === activeFilter
    ).selecteds = [];
    setSelectedFilters(newFilters);
    setReset(Math.random());
  }, [activeFilter, selectedFilters]);

  const resetFilters = useCallback(() => {
    //Seleciona todos os filtros possíveis
    let filters = [];

    columnsNames.forEach((attribute) => {
      tickets.forEach((ticket) => {
        if (filters.find((item) => item.attributeName === attribute.code)) {
          if (
            filters
              .find((item) => item.attributeName === attribute.code)
              .selecteds.indexOf(ticket[attribute.code]) === -1
          )
            filters
              .find((item) => item.attributeName === attribute.code)
              .selecteds.push(ticket[attribute.code]);
        } else {
          filters.push({
            attributeName: attribute.code,
            selecteds: [ticket[attribute.code]],
          });
        }
      });
    });
    setSelectedFilters(filters);
  }, [tickets]);


  //Atualiza os tickets filtrados
  useEffect(() => {
    const filteredItems = tickets.filter((ticket) => {
      let ok = true;
      selectedFilters.forEach((filter) => {
        if (filter.selecteds.indexOf(ticket[filter.attributeName]) === -1) {
          ok = false;
          return;
        }
      });

      return ok;
    });
    setFilteredTickets(filteredItems);
  }, [selectedFilters, reset, tickets]);


  useEffect(() => {
    setSidebarClosed(true);
    fetch(`${API_URL}tickets/list-all-canceled.php`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((response) => {
        setTickets(response);
        setFilteredTickets(response);

        if (!ordersIsFiltered) {
          setOrdersIsFiltered(true);
          //Seleciona todos os filtros possíveis
          let filters = [];

          columnsNames.forEach((attribute) => {
            response.forEach((ticket) => {
              if (
                filters.find((item) => item.attributeName === attribute.code)
              ) {
                if (
                  filters
                    .find((item) => item.attributeName === attribute.code)
                    .selecteds.indexOf(ticket[attribute.code]) === -1
                )
                  filters
                    .find((item) => item.attributeName === attribute.code)
                    .selecteds.push(ticket[attribute.code]);
              } else {
                filters.push({
                  attributeName: attribute.code,
                  selecteds: [ticket[attribute.code]],
                });
              }
            });
          });
          setSelectedFilters(filters);
        }

      });
  }, []);

  return (
    <Main status={reset}>
      <Sidebar />
      <Content sidebarclosed={sidebarClosed.toString()}>
        <SubTitle>Canceled</SubTitle>
        <Title>List</Title>
        <DownloadExcelWrapper>
          <DownloadTableExcel
            filename="Canceled-List"
            sheet="canceled-list"
            currentTableRef={tableRef.current}
          >
            <Button variant="outlined" style={{ marginBottom: "20px" }}>
              Export to excel
            </Button>
          </DownloadTableExcel>
        </DownloadExcelWrapper>
        <Tables>
          <Table ref={tableRef}>
            <thead>
              <tr>
              {columnsNames.map((column) => {
                  return (
                    <th
                      onClick={() => openFilter(column.code)}
                      className={`${
                        checkIfColumnIsFiltered(column.code) ? "active" : ""
                      }`}
                      key={column.code}
                    >
                      {column.name}
                    </th>
                  );
                })}
                {[1].indexOf(userPermissions) !== -1 && (
                  <th className="sticky-right"></th>
                )}
              </tr>
            </thead>
            <tbody>
              {filteredTickets.map((ticket) => {
                return (
                  <tr
                    key={ticket.ticket_id}
                    onClick={() => toggleSelectedLine(ticket.ticket_id)}
                    className={
                      selectedLines.indexOf(ticket.ticket_id) !== -1
                        ? "selected"
                        : ""
                    }
                  >
                    <td>{ticket.orderRef}</td>
                    <td>{ticket.orderPlataform}</td>
                    <td>{ticket.name}</td>
                    <td>{ticket.date}</td>
                    <td>{ticket.sector}</td>
                    <td>{ticket.currency}</td>
                    <td>{ticket.price}</td>
                    <td>{ticket.pax}</td>
                    <td>{ticket.contact}</td>
                    <td>{ticket.discount}</td>
                    <td>{ticket.country}</td>
                    <td>{ticket.cancelReason}</td>
                    <td>{ticket.createdBy}</td>
                    <td>{ticket.lastEditBy}</td>
                    {[1].indexOf(userPermissions) !== -1 && (
                      <>
                        <td className="sticky-right">
                          <Tooltip placement="top" title="Edit">
                            <EditButton
                              onClick={() => editOrder(ticket.order_id)}
                            />
                          </Tooltip>
                          <Tooltip placement="top" title="Restore">
                            <ReplayButton
                              onClick={() =>
                                unDeleteTicket(
                                  ticket.ticket_id,
                                  ticket.orderRef
                                )
                              }
                            />
                          </Tooltip>
                        </td>
                      </>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Tables>
        <Filter opened={(activeFilter !== false).toString()}>
          <FilterTitle>
            Filtering{" "}
            {activeFilter &&
              columnsNames.find((filter) => activeFilter === filter.code).name}
          </FilterTitle>
          <CloseFilter onClick={() => closeFilter()} />
          {activeFilter === "registeredDateFormated" ? (
            <>
            {/* <div className="date-filter">
              <TextField
                id={`start-${activeFilter}`}
                label="Start Date"
                variant="outlined"
                name={`start-${activeFilter}`}
                type="date"
                value={dateFilters.registeredDateFormated.start}
                onChange={(e) => changeDateFilter(e, activeFilter, "start")}
              />
              <TextField
                id={`end-${activeFilter}`}
                label="End Date"
                variant="outlined"
                name={`end-${activeFilter}`}
                type="date"
                value={dateFilters.registeredDateFormated.end}
                onChange={(e) => changeDateFilter(e, activeFilter, "end")}
              />
          </div>*/}
            </>
          ) : (
            <ul status={reset}>
              <div className="filters-actions">
                <span onClick={selectAll}>Select All</span>
                <span onClick={clearAll}>Clear All</span>
              </div>
              <div className="filters-search">
                <TextField
                  id="search"
                  label="Search"
                  variant="outlined"
                  name="search-orders-list"
                  value={search}
                  onChange={searchFilters}
                />
              </div>
              <div className="filters-options">
                {filtersOptions.map((option) => {
                  return (
                    <li key={option}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              id={option}
                              name={option}
                              onChange={(e) =>
                                changeFilter(e, activeFilter, option)
                              }
                              checked={checkFilterIsActive(option)}
                            />
                          }
                          label={
                            activeFilter === "fulfilled"
                              ? option === "1"
                                ? "Yes"
                                : "No"
                              : option
                          }
                        />
                      </FormGroup>
                    </li>
                  );
                })}
              </div>
            </ul>
          )}
        </Filter>
      </Content>
    </Main>
  );
};

export default OrderListCanceled;
